import { type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use CoreTable instead, this component shouldnt ever be created as it's not a table row.
 */
export const TableRow = ({
  label,
  subLabel,
  isDisabled = false,
  action,
  icon,
  position = "left",
  variant = "default",
  className,
  labelClassName,
}: {
  label?: string | null;
  subLabel?: string | null;
  isDisabled?: boolean;
  action?: ReactNode;
  icon?: ReactNode;
  position?: "left" | "right";
  variant?: "default" | "large";
  className?: string;
  labelClassName?: string;
}) => (
  <div
    className={cnTwMerge(
      "body-base-medium text-text/primary w-full flex items-center gap-3 py-4",
      isDisabled && "text-text/disabled cursor-not-allowed",
      position === "right" && "justify-end",
      variant === "default" && "min-h-14",
      variant === "large" && "min-h-[76px]",
      isTruthy(subLabel) && "py-3",
      className,
    )}
  >
    {icon ? <div className="ml-3">{icon}</div> : null}
    <div className="flex flex-col gap-1">
      <p
        className={cnTwMerge(
          "text-text/primary",
          isTruthy(subLabel) ? "body-base-medium" : "body-base-regular",
          labelClassName,
        )}
      >
        {label}
      </p>
      <p className="text-text/secondary body-small-regular">{subLabel}</p>
    </div>
    {action ? <div className="ml-auto mr-3">{action}</div> : null}
  </div>
);
